import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { CardType} from '../card-type/index';
import { Card, CardService } from '../card/index';
import { OnlineCatalogService } from './online-catalog.service';
import { Student, StudentService } from '../student/index';
import { School, SchoolService } from '../school/index';
import { Principal, CARD_UNLIMITED_BOOKINGS_NUMBER} from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BackOfficeService } from '../../shared';
import { PaymentItemService, PaymentItem } from '../payment-item';

@Component({
    selector: 'jhi-catalog',
    templateUrl: './catalog.component.html'
})
export class CatalogComponent implements OnInit, OnDestroy {
    cardTypes: CardType[];
    purchasedCard: Card;
    itemsPerPage: any;
    page: any;
    predicate: any;
    schoolId: number;
    student: Student;
    private subscription: any;
    public checkoutURLStatus: string;
    public checkoutSuccess: boolean;
    public checkoutError: boolean;
    public checkoutCancelled: boolean;
    private readonly CHECKOUT_SUCCESS = 'success';
    private readonly CHECKOUT_CANCEL = 'cancel';
    currentUserIsStudent: boolean;
    isLoadingCards: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private schoolService: SchoolService,
        private onlineCatalogService: OnlineCatalogService,
        private cardService: CardService,
        private studentService: StudentService,
        private paymentItemService: PaymentItemService,
        private alertService: AlertService,
        private backofficeService: BackOfficeService,
        private principal: Principal,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['cardType', 'card']);
        // TODO : remove this value and code pagination
        this.itemsPerPage = 200;
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.checkoutURLStatus = this.route.snapshot.queryParams['checkout']
            ?  this.route.snapshot.queryParams['checkout']
            : null;
        });

        this.principal.identity().then((account) => {
            this.principal
            .hasOnlyAuthority('ROLE_USER')
            .then((response) => this.currentUserIsStudent = response);
        });

        forkJoin(
            this.schoolService.findCurrent(),
            this.studentService.getCurrent()
        ).subscribe(([school, student]) => {
            if (!student) {
                this.setCheckoutErrorState();
                return;
            }

            this.schoolId = school.id;
            this.student = student;
            this.loadCatalog();

            if (this.checkoutURLStatus === this.CHECKOUT_CANCEL) {
                this.checkoutCancelled = true;
            } else if (this.checkoutURLStatus === this.CHECKOUT_SUCCESS) {
                this.handleCardCheckout();
            }
        },
            (error) => {
                this.onError(error);
            }
        );
    }

    private handleCardCheckout() {
        this.cardService.findLastCreatedByStudent(this.student.id).subscribe(
            (c: Card) => {
                if (!c.backofficeSessionId) {
                    // the card does not have backofficeSessionId, this is not the card that has been purchased
                    this.setCheckoutErrorState();
                    return;
                }

                let createdDate = new Date(c.createdDate);
                const tenMinutesAgo = new Date(Date.now() - 10 * 60 * 1000);
                const tenMinutesAfter = new Date(Date.now() + 10 * 60 * 1000);
                if (createdDate < tenMinutesAgo || createdDate > tenMinutesAfter ) {
                    // the card is either too old or is in the future, this is not the card that has been purchased
                    this.setCheckoutErrorState();
                    return;
                }

                this.purchasedCard = c;

                // check if there is a payment for the card
                this.paymentItemService.search({
                    query: 'card.id:' + c.id + ' AND _exists_:card.backofficeSessionId'
                }).subscribe(
                    (res: HttpResponse<PaymentItem[]>) => {
                        let paymentItems = res.body;
                        if (!paymentItems || paymentItems.length === 0 ) {
                            // the payment is in the backoffice, the card was created, but the payment is not in jyogui
                            this.setCheckoutErrorState();
                            return;
                        }

                        this.purchasedCard = c;
                        this.setCheckoutSuccessState();
                    },
                    (res: HttpErrorResponse) => this.onError(res)
                );
        }, (res: HttpErrorResponse) => {
            if (res.status === 404) {
                // the handleCheckout method is callend only when checking out, meaning that the card must have been created
                // it is not normal that we have a 404, but we show a human readable error
                this.setCheckoutErrorState();
            } else {
                this.onError(res);
            }
        });

    }

    private setCheckoutSuccessState() {
        if (this.checkoutURLStatus === this.CHECKOUT_SUCCESS) {
            this.checkoutSuccess = true;
        }
    }

    private setCheckoutErrorState() {
        if (this.checkoutURLStatus && this.checkoutURLStatus !== this.CHECKOUT_SUCCESS) {
            this.checkoutError = true;
        }
    }

    loadCatalog() {
        if (!this.schoolId) {
            return;
        }
        this.isLoadingCards = true;

        if (this.student) {
            this.onlineCatalogService.queryOnlineCatalog(this.schoolId, this.student.id, {
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(
                (res: HttpResponse<CardType[]>) => {
                    this.cardTypes = res.body;
                    this.isLoadingCards = false;
                },
                (res: HttpErrorResponse) => this.onError(res)
            );
        } else {
            this.onlineCatalogService.queryOnlineCatalogNoAuth(this.schoolId, {
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(
                (res: HttpResponse<CardType[]>) => {
                    this.cardTypes = res.body;
                    this.isLoadingCards = false;
                },
                (res: HttpErrorResponse) => this.onError(res)
            );
        }
    }

    // This functionality is to allow to create a card and a checkout session to pay online
    createCheckoutSessionForCard(cardType: CardType) {
        if (this.schoolId && this.student && cardType) {
            this.backofficeService
                .createCardWithCheckOutSession(this.schoolId, this.student.id, cardType.id)
                .subscribe((chechoutUrl: string) => {
                // we open the checkout session in same browser so the user can pay
                window.location.href = chechoutUrl;
            });
        }
    }

    ngOnDestroy() {

    }

    previousState() {
        window.history.back();
    }

    trackId(index: number, item: CardType) {
        return item.id;
    }

    getMaxAssistances() {
        return CARD_UNLIMITED_BOOKINGS_NUMBER;
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
        this.setCheckoutErrorState();
    }
    sort() {
        let result = ['name,asc'];
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/catalog.component.ts